export default __webpack_public_path__ + "static/media/recurring-icon8.ae4e0b64.png";